"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { sanitizeLessonHtml, type CustomPageKey } from "@growwithai/shared";
import { api } from "@/lib/api-client";
import { RICH_HTML_CLASS } from "@/components/landing/types";
import { LegalPage } from "./LegalPage";

// Halaman statis yang bisa dikustom admin tenant (app_settings page_*).
// - GET /api/public/pages/:key sukses → render konten tenant di shell
//   LegalPage yang sama dengan konten default.
// - 404 / error / belum ada konten → render children (JSX default eksisting).
// children dirender lebih dulu (bukan skeleton) supaya tenant tanpa
// kustomisasi — kasus paling umum — tidak melihat layar kosong.

interface PublicPageContent {
  title?: string;
  updated_at_label?: string;
  body_html?: string;
}
export default function CustomizablePage(t0) {
  const $ = _c(13);
  const {
    pageKey,
    defaultTitle,
    children
  } = t0;
  const [content, setContent] = useState(null);
  let t1;
  let t2;
  if ($[0] !== pageKey) {
    t1 = () => {
      let cancelled = false;
      api(`/api/public/pages/${pageKey}`, {
        cacheTtl: 300000
      }).then(res => {
        if (!cancelled && res.success && res.data?.body_html) {
          setContent(res.data);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [pageKey];
    $[0] = pageKey;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!content) {
    let t3;
    if ($[3] !== children) {
      t3 = <>{children}</>;
      $[3] = children;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t3 = content.title || defaultTitle;
  const t4 = content.updated_at_label;
  let t5;
  if ($[5] !== content.body_html) {
    t5 = sanitizeLessonHtml(content.body_html);
    $[5] = content.body_html;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className={`mt-6 ${RICH_HTML_CLASS}`} dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== content.updated_at_label || $[10] !== t3 || $[11] !== t6) {
    t7 = <LegalPage title={t3} updatedAt={t4}>{t6}</LegalPage>;
    $[9] = content.updated_at_label;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}